import { InputBox } from '../../../../design_system/components/Input Fields/InputBox.jsx'
import { ControlToggleRow } from './ControlsRows.jsx'

const DirectorySection = ({ fields, showCompanyIds, lnAliasesUrns, onLnAliasesChange, canEditControls, values, onToggle }) => (
    <>
        {showCompanyIds && (
            <div className="mt-m mb-s">
                <InputBox
                    inputStyle={{ maxWidth: 480 }}
                    label="Company IDs for Course, Branch and Graduation Year filters"
                    showLabel
                    placeholder="Placeholder"
                    value={lnAliasesUrns}
                    handleOnChange={onLnAliasesChange}
                    disabled={!canEditControls}
                />
            </div>
        )}
        {fields.map(field => (
            <ControlToggleRow
                key={field.id}
                label={field.label}
                description={field.description}
                checked={!!values[field.key]}
                disabled={field.disabled || !canEditControls}
                nested={!!field.parentKey}
                onToggleClick={() => onToggle(field.id)}
            />
        ))}
    </>
)

export default DirectorySection
